import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '../../../_service/message-service';
import { LoaderService } from 'src/app/loader.service';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';
import { UserService } from 'src/app/_services';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { TranslateService } from '@ngx-translate/core';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { UserTypes } from 'src/app/shared/interfaces/userType.model';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/_services';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};
@Component({
  selector: 'telio-rfid-assign',
  templateUrl: './rfid-assign.component.html',
  styleUrls: ['./rfid-assign.component.scss'],
  providers: [

    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class RfidAssignComponent implements OnInit {

  createRfid: UntypedFormGroup;
  favoriteSeason: string;
  minDate;
  enableMasterRfid = false;
  masterRfidList = [];
  nextyearDate;
  rfidTag;
  rfidDetails;
  search;
  userDetails;
  cookieDetails;
  searchForUser;
  showNoData: boolean = false;
  mobileNumbers: RegExp = /^[1-9]\d{7,9}$/gi;
  emailRegEX: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@,"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  disableSelect = new FormControl(false);
  showMasterCardList = true;
  position = 1;

  @ViewChild('searchAlert', { static: false }) searchAlert: TemplateRef<any>;

  constructor(private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private rfidService: RfidServiceService,
    private userInfoService: UserInfoService,
    public translate: TranslateService,
    private toastr: SnackbarService,
    public loaderService: LoaderService,
    private authenticationService:AuthenticationService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.rfidTag = params.rfidId;
    });
    this.rfidService.getMasterCards().subscribe(resp => {
      this.masterRfidList = resp.content;
    }, error => {
      this.toastr.error(error.message)
    }
    )
    this.rfidService.getRfidDetailsById(this.rfidTag).subscribe(resp => {
      this.rfidDetails = resp;
      this.editForm()
    })
    this.cookieDetails = this.userInfoService.userDetails;
  }

  editForm() {
    this.createRfid = this.formBuilder.group({
      rfid_tag: [{ value: this.rfidDetails ? this.rfidDetails.id_tag: '', disabled: true }, Validators.compose([
        Validators.required
      ])],
      user_id: ["", Validators.compose([
      ])],
      user_name: ["", Validators.compose([
      ])],
      start_date: [this.rfidDetails ? this.rfidDetails.created_date : '', Validators.required],
      expiration_date: [this.rfidDetails ? this.rfidDetails.expired_date : '', Validators.required],
      master_rfid: [''],
      comment: [this.rfidDetails ? this.rfidDetails.comments: ''],
      status: [this.rfidDetails ? this.rfidDetails.status : '']
    })
  }

  resetmethod(createRfid, formDirective) {
    this.ngOnInit()
  }

  onSubmit() {
    if (this.createRfid.value.user_id == "" || this.createRfid.value.user_name == "") {
      this.toastr.error(this.translate.instant('rfid.userIdError'))
      return
    }
    this.rfidService.assignRfid(this.authenticationService.convertToBase64(this.rfidDetails.id_tag), this.createRfid.value.user_id).subscribe(resp => {
      if (resp != null) {
        this.toastr.success(this.translate.instant('rfid.successAssign'))
        this.routeBack();
      }
    },
      error => {
        this.toastr.error(error.message);
      })
  }

  openDialog() {
    let dialogRef = this.dialog.open(this.searchAlert, {
      height: '500px',
      width: '800px'
    }).afterClosed().subscribe((res: any) => {
    })
  }

  searchUser() {
    let searchval = this.search.charAt(0);
    let hasNumber = /\d/;
    if (hasNumber.test(searchval)) {
      if (this.search.match(this.mobileNumbers)) {
        this.searchForUser = this.search
        this.getDetailsbySearch()
      }
      else {
        this.toastr.error(this.translate.instant('rfid.mobileError'))
        return
      }
    }
    else {
      if (this.emailRegEX.test(this.search)) {
        this.searchForUser = this.search
        this.getDetailsbySearch()
      }
      else {
        this.toastr.error(this.translate.instant('rfid.emailError'))
        return
      }
    }
  }

  getDetailsbySearch() {
    this.userService.getAllUsers(1, 10, 'username', 'asc', this.searchForUser, UserTypes.mobileUsers).subscribe(
      resp => {
        this.userDetails = resp.data.content[0].user;
        if (this.userDetails) {
          this.showNoData = false;
          if (this.userDetails.email == "" || this.userDetails.email == undefined) {
            this.userDetails.email = "Not Available"
          }
        }
        else {
          this.showNoData = true;
        }
      }
    )
  }

  selectUser() {
    this.createRfid.controls.user_name.setValue(this.userDetails.username);
    this.createRfid.controls.user_id.setValue(this.userDetails.userId);
    this.dialog.closeAll();
    this.userDetails = undefined;
    this.search = '';
  }

  closePopup() {
    this.dialog.closeAll();
    this.userDetails = undefined;
    this.search = '';
  }

  routeBack() {
    this.router.navigate(['/dashboard/rfid', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
  }

  showOptions(event) {
    if (event.checked) {
      this.createRfid.controls['master_rfid'].reset();
      this.showMasterCardList = false;
      this.position = 0;
    }
    else {
      this.showMasterCardList = true;
      this.position = 1;
    }
  }
}
